export const findShopId = (pathArray) => {
  if (pathArray.length > 2 && pathArray[0] === 'freight' && pathArray[1] === 'shop') {
    return location?.pathname?.split('/')[3];
  }
  return false;
};
